import emojiRegex from 'emoji-regex';

export const EMOJI_REG_EXP = emojiRegex();
